
import { beforeEnterBimex, beforeEnterCmmon } from "../method/method";
import knowledgeH5 from './knowledgeH5';
import approvalH5 from './approvalH5';

export default [
  ...knowledgeH5,
  ...approvalH5,
  // web端分享文件预览
  {
    path: "/appViewDwg",
    name: "appViewDwg",
    beforeEnter: beforeEnterBimex,
    component: () => import("@/CommonDP/mongeView/appView/dwgMax/index.vue")
  },
  {
    path: "/appViewModel",
    name: "appViewModel",
    beforeEnter: beforeEnterBimex,
    component: () => import("@/CommonDP/mongeView/appView/modelMax/index.vue")
  },
  {
    path: "/appViewOffice",
    name: "appViewOffice",
    beforeEnter: beforeEnterBimex,
    component: () => import("@/CommonDP/mongeView/appView/docView/office.vue")
  },
  {
    path: "/appViewPdf",
    name: "appViewPdf",
    beforeEnter: beforeEnterBimex,
    component: () => import("@/CommonDP/mongeView/appView/docView/pdf.vue")
  },
  {
    path: "/appViewImage",
    name: "appViewImage",
    beforeEnter: beforeEnterBimex,
    component: () => import("@/CommonDP/mongeView/appView/docView/image.vue")
  },
  {
    path: "/appViewTxt",
    name: "appViewTxt",
    beforeEnter: beforeEnterBimex,
    component: () => import("@/CommonDP/mongeView/appView/docView/txt.vue")
  },
  // 我的审批
  {
    path: '/project-myApplicationH5',
    name: 'myApplicationH5',
    beforeEnter: beforeEnterCmmon,
    component: () => import('@/CommonDP/pages/mainMg/project/approvalFlowH5/myApplicationH5.vue')
  },
  {
    path: '/project-handleApplicationH5',
    name: 'handleApplicationH5',
    component: () =>
      import('@/CommonDP/pages/mainMg/project/approvalFlowH5/flowDetail.vue')
  },
  {
    path: "/appAgreementPrivacy",
    name: "agreementPrivacy",
    beforeEnter: beforeEnterCmmon,
    component: () => import("@/CommonDP/mongeView/appView/agreement/privacyContent.vue")
  },
  {
    path: "/appAgreementuesrLicense",
    name: "agreementuesrLicense",
    beforeEnter: beforeEnterCmmon,
    component: () => import("@/CommonDP/mongeView/appView/agreement/uesrLicenseContent.vue")
  },
  {
    path: "/appAgreementPrivacyhead",
    name: "agreementPrivacyhead",
    component: () => import("@/CommonDP/mongeView/appView/agreement/privacyhead.vue")
  },
  {
    path: "/appAgreementuesrLicensehead",
    name: "agreementuesrLicensehead",
    component: () => import("@/CommonDP/mongeView/appView/agreement/uesrLicensehead.vue")
  },

  {
    path: "/examine-approve-detail",
    name: "approvalDetail",
    beforeEnter: beforeEnterCmmon,
    component: () => import("@/CommonDP/components/processComponents/flow/flowDialogSummary.vue")
  },
  {
    path: "/examine-new",
    name: "approvalNew",
    beforeEnter: beforeEnterCmmon,
    component: () => import("@/CommonDP/components/processComponents/flowNew/iframeFlow.vue")
  },
  {
    path: "/iframeMember",
    name: "iframeMember",
    beforeEnter: beforeEnterCmmon,
    component: () => import("@/CommonDP/components/chooseMember/iframeMember.vue")
  },
  {
    path: "/iframeMemberEnterpriseDeptDoc",
    name: "iframeMemberEnterpriseDeptDoc",
    beforeEnter: beforeEnterCmmon,
    component: () => import("@/CommonDP/pages/mainMg/doc/enterpriseDeptDoc/index.vue")
  },
  // 消息
  {
    path: "/messageH5",
    name: "messageH5",
    component: () => import("@/CommonDP/pages/appView/messageH5/messageH5.vue"),
    beforeEnter: beforeEnterCmmon
  },
  {
    path: "/revitRuleSet",
    name: "revitRuleSet",
    beforeEnter: beforeEnterCmmon,
    component: () => import("@/CommonDP/pages/mainMg/application/standard/revitSet/ruleSet.vue")
  }
];
